import _ from 'lodash';
import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { Button } from '@deerplusofficial/pos-components';
import InfoSection from '../Info/InfoSection';
import Info from '../Info/Info';

const ButtonWrapper = styled.div`
  display: grid;
  grid-gap: 10px;
  grid-template-columns: 1fr 1fr 1fr;
`;

class Option extends React.PureComponent {
  static propTypes = {
    children: PropTypes.string,
    highlight: PropTypes.bool,
    onSelect: PropTypes.func,
  };

  static defaultProps = {
    children: '',
    highlight: false,
    onSelect: _.identity,
  };

  onClick = () => {
    const { children, onSelect } = this.props;
    onSelect(children);
  };

  render() {
    const { highlight, disabled, children } = this.props;

    return (
      <Button
        dense
        cancel
        disabled={disabled}
        highlight={highlight}
        onClick={this.onClick}
      >
        {children}
      </Button>
    );
  }
}

export default class SpecSelector extends React.PureComponent {
  static propTypes = {
    disabled: PropTypes.bool,
    label: PropTypes.string,
    value: PropTypes.string,
    options: PropTypes.arrayOf(PropTypes.string),
    onSelect: PropTypes.func,
  };

  static defaultProps = {
    disabled: false,
    label: '',
    value: '',
    options: [],
    onSelect: _.identity,
  };

  onSelect = value => {
    const { label, onSelect } = this.props;

    onSelect({ label, value });
  };

  render() {
    const { label, options, value, disabled } = this.props;

    return (
      <InfoSection>
        <Info flex label={label}>
          <ButtonWrapper>
            {_.map(options, option => (
              <Option
                key={option}
                disabled={disabled}
                highlight={option === value}
                onSelect={this.onSelect}
              >
                {option}
              </Option>
            ))}
          </ButtonWrapper>
        </Info>
      </InfoSection>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/ProductModal/SpecSelector.js